import { createSelector } from "@reduxjs/toolkit";
import { firstOrDefault } from "Utils/Array";
import { IState } from "../../Model/State/IState";
import { selectSelectedOrActiveProjectIds, selectSelectedOrActiveProjects } from "./Projects";

export function selectShowDeleteDialog(state: IState): boolean {
  return state.delete.showDialog;
}

export const selectDeletingProject = createSelector(
  (state: IState) => selectSelectedOrActiveProjects(state),
  (selectedProjects) => firstOrDefault(selectedProjects)
);

export const selectDeletingProjectId = createSelector(
  (state: IState) => selectSelectedOrActiveProjectIds(state),
  (selectedProjectIds) => firstOrDefault(selectedProjectIds)
);
